import React from 'react';
import './styles.scss';

const FullScreen = ({ children }) => <div className="full-screen-bg">{children}</div>;
export default FullScreen;
